import React, { useEffect } from 'react'
import { Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import MunicipalLogos from './components/MunicipalLogos'
import About from './components/About'
import Services from './components/Services'
import BeforeAfter from './components/BeforeAfter'
import Collaboration from './components/Collaboration'
import ContactForm from './components/ContactForm'
import Footer from './components/Footer'
import ScrollToTopAndHash from './components/ScrollToTopAndHash'
import ServiceDetail from './pages/ServiceDetail'
import Contact from './pages/Contact'

// Forside-komponent der samler alle sektioner
function Home() {
  return (
    <>
      {/* Hero Section */}
      <Hero />

      {/* Rullende kommunelogoer */}
      <MunicipalLogos />

      {/* About Section */}
      <About />

      {/* Services Section */}
      <Services />

      {/* Before & After Section */}
      <BeforeAfter />

      {/* Collaboration Section */}
      <Collaboration />

      {/* Contact Form & Info Section */}
      <ContactForm showFullInfo={false} />
    </>
  )
}

// 301 Redirect Handler for old or incorrect URLs
function RedirectHandler() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const path = location.pathname
    
    // Redirect mapping
    const redirects = {
      '/about': '/#om-os',
      '/services': '/#ydelser',
      '/en/about': '/en#om-os',
      '/en/services': '/en#ydelser',
      '/da': '/',
      '/da/kontakt': '/kontakt',
    }

    // Direct match redirects
    if (redirects[path]) {
      navigate(redirects[path], { replace: true })
      return
    }

    // Pattern matching redirects
    // 1. Redirect /en/ydelser/:slug to /en/services/:slug
    if (path.startsWith('/en/ydelser/')) {
      const slug = path.replace('/en/ydelser/', '')
      navigate(`/en/services/${slug}`, { replace: true })
      return
    }

    // 2. Redirect /da/ydelser/:slug to /ydelser/:slug
    if (path.startsWith('/da/ydelser/')) {
      const slug = path.replace('/da/ydelser/', '')
      navigate(`/ydelser/${slug}`, { replace: true })
      return
    }

    // 3. Redirect /da/services/:slug to /ydelser/:slug
    if (path.startsWith('/da/services/')) {
      const slug = path.replace('/da/services/', '')
      navigate(`/ydelser/${slug}`, { replace: true })
      return
    }
  }, [location.pathname, navigate])

  return null
}

function App() {
  return (
    <div className="relative min-h-screen bg-[#FAF8F5] text-[#2C302E] antialiased selection:bg-[#a78458]/10 selection:text-[#a78458]">
      {/* Scroll- og Hash-håndtering på tværs af ruter */}
      <ScrollToTopAndHash />

      {/* Håndterer 301 redirects */}
      <RedirectHandler />

      {/* Navigationsbar */}
      <Navbar />
      
      <main>
        <Routes>
          {/* Danske ruter */}
          <Route path="/" element={<Home />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/kontakt" element={<Contact />} />
          
          {/* Engelske ruter */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/services/:slug" element={<ServiceDetail />} />
          <Route path="/en/contact" element={<Contact />} />
          
          {/* Fallback rute - omdirigerer til forsiden */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
